export default "__VITE_ASSET__$Mi$cHNr__"